<template>
  <div
    style="width: 100%"
    v-loading.body="loading"
    element-loading-text="Loading..."
  >
    <el-row
      type="flex"
      align="middle"
      justify="end"
      style="border-bottom: 1px solid lightgrey"
    >
      <HeaderInfoText :colspan="9" :title="getTitle" />
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-button
            plain
            @click="generateReport"
            :disabled="disableReportRun || !requirementsMet"
            style="margin: 0 15px"
          >
            Run report
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row
          type="flex"
          align="middle"
          justify="start"
          style="font-size: 1.2em"
        >
          Report Options
        </el-row>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <p><sup>*</sup> Denotes a required field</p>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="top">
      <el-col :span="12">
        <el-row type="flex" align="middle" justify="start" class="headerRow">
          <el-col :span="6">
            <div style="display: inline-flex">Bank Account*</div>
          </el-col>
          <el-col :span="18">
            <el-select
              v-model="selectedCodes.bank__in"
              :multiple="false"
              placeholder="Bank Account"
              required
            >
              <el-option
                v-for="opt in allCodes.bank__in.choices"
                :key="opt.value"
                :label="opt.display_name"
                :value="opt.value"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" justify="start" class="headerRow">
          <el-col :span="6">
            <div style="display: inline-flex">Company*</div>
          </el-col>
          <el-col :span="18">
            <el-select
              v-model="selectedCodes.company__in"
              :multiple="true"
              placeholder="All"
              required-multiselect
            >
              <el-option
                v-for="opt in allCodes.company__in.choices"
                :key="opt.value"
                :label="opt.display_name"
                :value="opt.value"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" justify="start" class="headerRow">
          <el-col :span="6"> Production* </el-col>
          <el-col :span="18">
            <el-select
              v-model="selectedCodes.production__in"
              :multiple="true"
              placeholder="All"
              required-multiselect
            >
              <el-option
                v-for="opt in allCodes.production__in.choices"
                :key="opt.value"
                :label="opt.display_name"
                :value="opt.value"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" justify="start" class="headerRow">
          <el-col :span="6"> Report Output </el-col>
          <el-col :span="18">
            <el-select v-model="reportOptions.format">
              <el-option
                v-for="opt in reportOutputFormats"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" justify="start" class="headerRow">
          <el-col :span="6">
            Payment Status
          </el-col>
          <el-col :span="18">
            <el-select v-model="selectedCodes.payment_status" placeholder="All">
              <el-option
                v-for="opt in paymentOutputFormats"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value "
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" justify="start" class="headerRow">
          <el-col :span="6">
            Include Summary Table
          </el-col>
          <el-col :span="18">
            <el-checkbox v-model="selectedCodes.summary_table" id="summary" name="summary"></el-checkbox>
          </el-col>
          </el-row>

        <!-- <el-row type="flex" align="middle" justify="start" class="headerRow">
          <el-col :span="6">
            Run By
          </el-col>
          <el-col :span="18">
            <el-select v-model="selectedCodes.payment_status" placeholder="All">
              <el-option
                v-for="opt in paymentOutputFormats"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>
          </el-col>
        </el-row> -->
        <el-row type="flex" align="middle" justify="start" class="headerRow">
          <el-col :span="6"> Run By </el-col>
          <el-col :span="18">
            <el-radio-group
              v-model="selectedOption"
              @change="updateSelectedOption"
            >
              <el-radio-button label="all">All</el-radio-button>
              <el-radio-button label="date_range">Date Range</el-radio-button>
              <el-radio-button label="check_range">Check Range</el-radio-button>
              <el-radio-button label="check_run">Check Run</el-radio-button>
              <el-radio-button label="payment_type"
                >Payment Type</el-radio-button
              >
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          align="middle"
          justify="start"
          class="headerRow"
          v-if="selectedOption === 'date_range'"
        >
          <el-col :span="24">
            <el-row style="margin: 12px 0">Date Range</el-row>
            <el-row type="flex" align="middle">
              <el-col :span="3">
                <el-row
                  type="flex"
                  align="middle"
                  justify="end"
                  style="padding: 0 12px"
                >
                  Start
                </el-row>
              </el-col>
              <el-col :span="8">
                <DateField v-model="selectedCodes.posted_date_start" />
              </el-col>
              <el-col :span="1" />
              <el-col :span="3">
                <el-row
                  type="flex"
                  align="middle"
                  justify="end"
                  style="padding: 0 12px"
                >
                  End
                </el-row>
              </el-col>
              <el-col :span="8">
                <DateField v-model="selectedCodes.posted_date_end" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          align="middle"
          justify="start"
          class="headerRow"
          v-if="selectedOption === 'check_range'"
        >
          <el-col :span="24">
            <el-row style="margin: 12px 0">Check Range</el-row>
            <el-row type="flex" align="middle">
              <el-col :span="3">
                <el-row
                  type="flex"
                  align="middle"
                  justify="end"
                  style="padding: 0 12px"
                >
                  Start
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-input v-model="selectedCodes.check_number__gte" />
              </el-col>
              <el-col :span="1" />
              <el-col :span="3">
                <el-row
                  type="flex"
                  align="middle"
                  justify="end"
                  style="padding: 0 12px"
                >
                  End
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-input v-model="selectedCodes.check_number__lte" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          align="middle"
          justify="start"
          class="headerRow"
          v-else-if="selectedOption === 'check_run'"
        >
          <el-col :span="24">
            <el-row type="flex" align="middle">
              <el-col :span="6"> Check Run </el-col>
              <el-col :span="18">
                <el-select
                  v-model="selectedCodes.check_run"
                  :multiple="false"
                  placeholder="Select a check run"
                  filterable
                >
                  <el-option
                    v-for="opt in allCodes.check_run.choices"
                    :key="opt.value"
                    :label="opt.display_name"
                    :value="opt.value"
                  />
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          align="middle"
          justify="start"
          class="headerRow"
          v-else-if="selectedOption === 'payment_type'"
        >
          <el-col :span="24">
            <el-row type="flex" align="middle">
              <el-col :span="6"> Payment Type </el-col>
              <el-col :span="18">
                <el-row type="flex" align="middle" justify="start">
                  <el-checkbox v-model="selectedCodes.include_computer_check" />
                  <span style="margin: 6px;">Include Computer Checks</span>
                </el-row>
                <el-row type="flex" align="middle" justify="start">
                  <el-checkbox v-model="selectedCodes.include_manual" />
                  <span style="margin: 6px">Include Manual Checks</span>
                </el-row>
                <el-row type="flex" align="middle" justify="start">
                  <el-checkbox v-model="selectedCodes.include_eft" />
                  <span style="margin: 6px">Include EFTs</span>
                </el-row>
                <el-row type="flex" align="middle" justify="start">
                  <el-checkbox v-model="selectedCodes.include_wire_transfers" />
                  <span style="margin: 6px">Include Wire Transfers</span>
                </el-row>
                <el-row type="flex" align="middle" justify="start">
                  <el-checkbox v-model="selectedCodes.include_voided" />
                  <span style="margin: 6px">Include Voided</span>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="6" />
      <el-col :span="6">
        <el-row type="flex" align="start" justify="end">
          <div
            class="check-register-errors"
            style="color: indianred; padding: 0 12px"
          >
            <ul>
              <li v-for="msg in errorMessages">
                {{ msg }}
              </li>
            </ul>
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import HeaderInfoText from '@/components/HeaderInfoText'
import DateField from '@/components/InputComponents/DateField'
import store from '@/store/store'
import { reportMixins } from '@/Mixins/Reports'

export default Vue.extend({
  name: 'CheckRegister',
  mixins: [reportMixins],
  components: {
    HeaderInfoText,
    DateField
  },
  data () {
    return {
      rawChoices: [],
      opts: null,
      reportEndpoint: 'checks/register/', // excluding "reports/" prefix to allow use with function startRenderingReport
      instance: {},
      token: '',
      reportOptions: {
        // Options to run report.
        type: 'default', // Default template
        templates: [], // From OPTIONS call
        format: 'pdf' // Hidden for this report, but theoretically used to select pdf, csv, etc.
      },
      allCodes: {
        // Show codes, e.g. accounts, series, locations, sets, etc.
        bank__in: { choices: [] },
        company__in: { choices: [] },
        production__in: { choices: [] },
        check_run: { choices: [] },
        vendor__in: { choices: [] }
      },
      selectedCodes: {
        // User selected codes from choices of allCodes above
        company__in: [],
        production__in: [],
        bank__in: '',
        check_run: null,
        posted_date_start: null,
        posted_date_end: null,
        check_number__gte: null,
        check_number__lte: null,
        vendor__in: [],
        include_manual: true,
        include_computer_check: true,
        include_wire_transfers: true,
        include_eft: true,
        include_voided: true
      },
      disableReportRun: false, // Disable run report button if false
      loading: false,
      selectedOption: 'all',
      prettyJson: undefined,
      reportOutputFormats: [
        { value: 'pdf', label: 'PDF' },
        { value: 'csv', label: 'CSV' }
      ],
      paymentOutputFormats: [
          { value: 'All', label: 'All ' },
          { value: 'pending', label: 'Pending' },
          { value: 'cleared', label: 'Cleared' }
      ]
    }
  },
  methods: {
    /**
     * Updates the selected radio button option (date_range or check_run)
     * @param option
     */
    updateSelectedOption (option) {
      this.selectedCodes.include_manual = true
      this.selectedCodes.include_computer_check = true
      this.selectedCodes.include_wire_transfers = true
      this.selectedCodes.include_eft = true
      this.selectedCodes.include_voided = true
      switch (option) {
        case 'date_range':
          this.selectedCodes.check_run = null
          this.selectedCodes.check_number__gte = null
          this.selectedCodes.check_number__lte = null
          break
        case 'check_run':
          this.selectedCodes.posted_date_start = null
          this.selectedCodes.posted_date_end = null
          this.selectedCodes.check_number__gte = null
          this.selectedCodes.check_number__lte = null
          break
        case 'check_range':
          this.selectedCodes.posted_date_start = null
          this.selectedCodes.posted_date_end = null
          this.selectedCodes.check_run = null
          break
        case 'all':
          this.selectedCodes.check_number__gte = null
          this.selectedCodes.check_number__lte = null
          this.selectedCodes.posted_date_start = null
          this.selectedCodes.posted_date_end = null
          this.selectedCodes.check_run = null
      }
      this.selectedOption = option
    },
    /**
     * Resets the component?
     */
    resetComponent () {
      this.clearStore()
    },
    /**
     * Clears all cached data from OPTIONS response from the store to avoid store bloating and stale data
     */
    clearStore () {
      this.$store.dispatch('clearFormFields', 'reports/checks/register/')
    },
    /**
     * Sets the report format ('csv' or 'pdf')
     * @param   target
     */
    selectReportFormat ({ target }) {
      this.reportOptions.format = target.checked ? 'csv' : 'pdf'
    },
    /**
     * Performs basic validation, e.g. are required fields selected
     * @return {boolean}
     */
    checkRequiredElementFields () {
      /* Add "required" to el-select and "required-multiselect" to multiple selectors, e.g.
        Single select:
          <el-select v-model="bank" :multiple="false" placeholder="Bank Account" required>

        Multiple select:
          <el-select v-model="company" :multiple="true"  placeholder="All" required-multiselect>
      */
      let errorCount = 0
      const requiredInputFields = this.$el.querySelectorAll('[required] input') // Works for el-select (non-multiple)/input tags
      for (const field of requiredInputFields) {
        field.classList.remove('form-error')
        if (field && !field.value) {
          field.classList.add('form-error')
          errorCount++
        }
      }
      const requiredMultiSelectFields = this.$el.querySelectorAll(
        '[required-multiselect]'
      ) // Need this for multiple-select el-select boxes
      for (const field of requiredMultiSelectFields) {
        field.querySelector('input').classList.remove('form-error')
        if (
          field &&
          field.querySelectorAll('.el-select__tags-text').length === 0
        ) {
          field.querySelector('input').classList.add('form-error')
          errorCount++
        }
      }
      return !errorCount
    },
    /**
     * Generates the Check Register report. First, caches parameters, gets async report and hands off
     * to Ian's report builder
     * @return {Promise<boolean>}
     */
    async generateReport () {
      for (const i in this.allCodes) {  // Go through report option fields
        const choices = this.allCodes[i].hasOwnProperty('choices') ? this.allCodes[i].choices : false // Autoselect banks, companies, productions
        if (i === 'company__in') {
          this.rawChoices = choices.map(choice => choice.value)
        }
        if (i === 'production__in') {
          this.rawChoices = choices.map(choice => choice.value)
        }
      }
      if (this.selectedCodes.bank__in.length === 0) {
        if (!this.checkRequiredElementFields()) {
          return false
        }
      }
      if (this.selectedCodes.payment_status === '') {
        this.selectedCodes.payment_status = 'All'
      }
      const data = { ...this.selectedCodes }
      this.loading = true
      this.disableReportRun = true
      for (const code in data) {
        if (data.hasOwnProperty(code) && !data[code]) {
          delete data[code]
          continue
        }
        const fieldParameters = this.getReportFormFields(`reports/${this.reportEndpoint}`)[code]
        const isRequired = fieldParameters ? fieldParameters.required : false
        if (Array.isArray(data[code]) && !data[code].length && !isRequired) {
          delete data[code]
        }
      }
      try {
        let result = data
        result['company__in'] = this.selectedCodes.company__in.length === 0 ? this.rawChoices : this.selectedCodes.company__in
        result['production__in'] = this.selectedCodes.production__in.length === 0 ? this.rawChoices : this.selectedCodes.production__in
        const resp = await this.$store.dispatch('cacheParams', { data: result })
        if (!(resp && resp.id)) {
          throw new Error('Error caching parameters for check register report')
        }
        const { id, reportId } = resp
        // Make a CSV
        if (this.reportOptions.format === 'csv') {
          const data = await this.getRawReport('checks/register', id)
          if (!data) {
            this.createNotification('Error', 'Failed to generate data. ', 'error')
            return false
          }
          // To make this work with existing apps, must use the `prettyJson` property
          this.prettyJson = this.buildCsvData(data.report)
          this.createNotification('Success', 'CSV is Ready. ', 'success', false, true, 'CheckRegister')
          return true
          // Run a traditional report
        } else {
          const payload = { query: { cached_parameters: id, report_template: this.reportOptions.type }, type: this.reportEndpoint, reportId }
          this.$store.dispatch('startRenderingReport', payload)
        }
      } catch (e) {
        console.log(e)
        return e
      } finally {
        this.loading = false
        this.disableReportRun = false
      }
    },
      /**
     * Allows a report to be generated as CSV
     * @param report
     */
    buildCsvData (report) {
      if (!report || !Array.isArray(report.data)) {
        this.createNotification('Error', 'Failed to generate data. ', 'error')
        return false
      }
      // Write out CSV and add header data to record
      let ledgerData = report.data.map((check) => {
        check.bank = report.bank
        check.currency = report.currency
        check.status =
          check.status === 'POSTED' || check.status === 'CLOSED'
            ? 'PAID'
            : check.status
        return check
      })
      this.disableReportRun = false
      const columnMap = {
        Bank: 'bank',
        Type: 'payment_type',
        Vendor: 'vendor_name',
        'Check Number': 'payment_number',
        'Check Date': 'payment_date',
        Amount: 'amount',
        Status: 'status',
        Cleared: 'cleared'
      }
      let finalCsv = this.createCsv(ledgerData, columnMap)
      if (finalCsv) return finalCsv
      else {
        this.createNotification('Error', 'Failed to generate data. ', 'error')
        return false
      }
    },
    /**
     * Initializes component data
     * @param data
     */
    initializeData (data) {
      this.selectedCodes.company__in = []
      this.selectedCodes.production__in = []
      this.allCodes = { ...data.parameters }
      this.reportOptions.templates = { ...data.templates }
      let tmp = { ...this.selectedCodes }
      for (const i in this.allCodes) {
        // Go through report option fields
        const choices = this.allCodes[i].hasOwnProperty('choices')
          ? this.allCodes[i].choices
          : false // Autoselect banks, companies, productions
        if (!(choices && Array.isArray(choices))) {
          continue
        }
        if (i === 'check_run') {
          // Sending the default value empty
          tmp = this.selectDefaultCheck(tmp)
          continue
        }
        if (i === 'base_currency') {
          // Sending the default value empty
          tmp = this.selectDefaultBasecurrency(tmp)
          continue
        }
        if (i === 'bank__in') {
          // Set the default bank
          tmp = this.selectDefaultBank(tmp)
          continue
        }
        if (choices.length === 1) {
          if (tmp[i] && Array.isArray(tmp[i])) {
            // If one choice is available, select it automatically
            tmp[i].push(choices[0].value)
          } else {
            tmp[i] = choices[0].value
          }
        }
        // else if (i === 'company__in' || i === 'production__in') {
        //   // Really only needed if multiple companies or productions exist
        //   tmp[i] = choices.map((choice) => choice.value)
        // }
      }
      this.selectedCodes = { ...tmp }
    },
    /**
     * Selects the default bank, if it exists.
     */
    selectDefaultBank (selectedCodes) {
      let tmp = { ...selectedCodes }
      if (
        !tmp.bank__in &&
        this.allCodes.bank__in.choices.length &&
        this.defaultBank.id
      ) {
        const defaultBankChoice = this.allCodes.bank__in.choices.find(
          (choice) => choice.value === this.defaultBank.id
        )
        tmp.bank__in = defaultBankChoice.value || ''
      }
      return tmp
    },
    selectDefaultCheck (selectedCodes) {
      let tmp = { ...selectedCodes }
      tmp.check_run = null
      return tmp
    },
    selectDefaultBasecurrency (selectedCodes) {
      let tmp = { ...selectedCodes }
      tmp.base_currency = null
      return tmp
    }
  },
  computed: {
    ...mapGetters({
      getReportFormFields: 'getReportFormFields',
      defaultBank: 'getDefaultBank',
      dataLoaded: 'getInitDataLoadedStatus'
    }),
    /**
     * Checks whether the specified check range is valid. Validity is true if:
     * - neither check_number__gte or check_number__lte are specified, or
     * - either check_number__gte or check_number__lte are existing valid integers, but not both (bitwise XOR returns 1), or
     * - both are existing valid integers, and check_number__gte is less than check_number__lte.
     */
    /* eslint-disable camelcase */
    checkRangeIsValid () {
      const { check_number__gte, check_number__lte } = this.selectedCodes
      if (!(check_number__gte && check_number__lte)) {
        return true
      }

      const isStr =
        /^[a-zA-Z]+$/.test(check_number__gte) &&
        /^[a-zA-Z]+$/.test(check_number__lte)

      const isNum =
        /^[0-9]+$/.test(check_number__gte) &&
        /^[0-9]+$/.test(check_number__lte)

      if (
        !isStr &&
        !isNum &&
        check_number__gte.replace(/[^a-zA-Z]/g, '').toLowerCase() !==
          check_number__lte.replace(/[^a-zA-Z]/g, '').toLowerCase()
      ) {
        return false
      }

      const checkCompare = check_number__gte.localeCompare(
        check_number__lte,
        undefined,
        { numeric: true, sensitivity: 'base' }
      )
      return (
        check_number__gte &&
        check_number__gte.length &&
        check_number__lte &&
        check_number__lte.length &&
        checkCompare <= 0 &&
        (check_number__gte.length === check_number__lte.length ||
          (isNum && check_number__gte.length < check_number__lte.length))
      )
    },
    /**
     * Checks whether the specified posted date range is valid. Validity is true if:
     * - neither posted_date_start or posted_date_end are specified, or
     * - either posted_date_start or posted_date_end are specified, but not both (bitwise XOR returns 1), or
     * - both are existing, and posted_date_start is before posted_date_end.
     */
    dateRangeIsValid () {
      const { posted_date_start, posted_date_end } = this.selectedCodes
      if (!(posted_date_start && posted_date_end)) {
        return true
      }
      if (!!posted_date_start ^ !!posted_date_end) {
        return true
      }
      return (
        posted_date_start &&
        posted_date_end &&
        new Date(posted_date_start) <= new Date(posted_date_end)
      )
    },
    /**
     * Returns an array of error messages, if any.
     */
    errorMessages () {
      let errors = []
      if (!this.checkRangeIsValid) {
        errors.push(
          'Invalid Check Range specified. Please specify a valid start and end range, and an end ' +
            'range should be greater than or equal to the start range.'
        )
      }
      if (!this.dateRangeIsValid) {
        errors.push('Invalid Date Range specified.')
      }
      return errors
    },
    /**
     * Returns a boolean indicating whether the required values have been provided.
     */
    requirementsMet () {
      let met = []
      const fields = this.getReportFormFields(`reports/${this.reportEndpoint}`)
      const form = { ...this.selectedCodes }
      for (let field in fields) {
        if (!fields[field].required) {
          continue
        }
        met.push(!!form[field])
        // if (fields[field].many && field !== 'bank__in') {
        //   met.push(!!(Array.isArray(form[field]) && form[field].length))
        // } else {
        //   met.push(!!form[field])
        // }
      }
      return (
        met.length &&
        met.every((requirement) => !!requirement) &&
        this.checkRangeIsValid &&
        this.dateRangeIsValid
      )
    },
    getTitle () {
      return this.$route.meta.prettyName === 'Payment Register'
        ? 'Payment Register'
        : 'Check Register'
    }
  },
  watch: {
    dataLoaded () {
      if (this.dataLoaded) {
        this.selectedCodes = this.selectDefaultBank(this.selectedCodes)
      }
    }
  },
  /**
   * Vue-router hook, called before route enter
   */
  async beforeRouteEnter (to, from, next) {
    try {
      const opts = await store.dispatch(
        'fetchFormFields',
        'reports/checks/register/'
      )
      if (!opts) {
        throw new Error('Unable to fetch report options')
      }
      next((vm) => vm.initializeData(opts))
    } catch (e) {
      console.log(e)
    }
  },
  /**
   * Resets the component before it's destroyed
   */
  beforeDestroy () {
    this.resetComponent()
  }
})
</script>
<style scoped>
.small {
  font-size: 8px;
}

.right {
  float: right;
  text-align: right;
  padding: 0px 5px;
}

.left {
  float: left;
  text-align: left;
  padding: 0px 5px;
}

.selectRow {
  padding: 0px 20px;
}

.section {
  padding: 40px 20px 0px;
}

.headerRow {
  padding: 15px 20px 0px;
}

.m-right-20 {
  margin-right: 20px;
}

.m-top-50 {
  margin-top: 50px;
}

.date {
  display: inline-flex;
}

.field {
  margin: 0 6px;
}
</style>
<style>
.el-select {
  display: block;
}

.el-transfer-panel {
  width: 36%;
  max-width: 350px;
}

.el-transfer-panel__body {
  min-height: 400px;
}

.el-transfer-panel__list {
  min-height: 360px;
}

.form-error {
  background-color: #f08080;
  font-weight: bold;
  color: #000000;
}

/* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>



// WEBPACK FOOTER //
// src/components/Reports/CheckRegister.vue